var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.44861539e-14,
    y1: 4.55757576,
    x2: 31.9030303,
    y2: 4.55757576,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.369697,3.39824787e-15 L12.5333333,3.39824787e-15 C11.2747935,3.39824787e-15 10.2545455,1.02024809 10.2545455,2.27878788 L10.2545455,4.55757576 L21.6484848,4.55757576 L21.6484848,2.27878788 C21.6484848,1.02024809 20.6282368,3.39824787e-15 19.369697,3.39824787e-15 Z",
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5333333,
    y1: 23.9272727,
    x2: 12.5333333,
    y2: 12.5333333,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.369697,
    y1: 23.9272727,
    x2: 19.369697,
    y2: 12.5333333,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3807677,29.8126222 C26.2827595,30.9941469 25.2951584,31.9030303 24.1095758,31.9030303 L7.79497374,31.9030303 C6.60939112,31.9030303 5.62178998,30.9941469 5.52378182,29.8126222 L3.41818182,4.55757576 L28.4848485,4.55757576 L26.3807677,29.8126222 Z",
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2f3bc7503634f138a27e5697c5859e9b.svg";
export { ForwardRef as ReactComponent };